// used by Selenium and guided tour to target elements
export enum ElementId {
  NavigationMenu = 'NavigationMenu',
  AddNew = 'AddNew',
  AddNewSequencedContent = 'AddNewSequencedContent',
  AddNewNonSequencedContent = 'AddNewNonSequencedContent',
  AddNewQuiz = 'AddNewQuiz',
  AddNewSubmenu = 'AddNewSubmenu',
  EditSqItemName = 'EditSqItemName',
  AddNewItemButton = 'AddNewItemButton',

  AddNewAction = 'AddNewAction',
  AddNewQuestion = 'AddNewQuestion',
  AddNewSplitSequence = 'AddNewSplitSequence',

  RestartGuidedTour = 'RestartGuidedTour',

  Loader = 'Loader',
  NextNavigationButton = 'NextNavigationButton',
  FinishNavigationButton = 'FinishNavigationButton',
}
